<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('price.servicesPriceList') }} <span class="text-danger">({{ $t('price.unitPricesIn') }} {{ selectedCurrencySymbol }})</span>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <table
        v-if="foundedRanges.length && foundedServices.length"
        class="table">
        <thead>
          <th>{{ $t('ui.pieces') }}:</th>
          <th
            v-for="(range, index) of foundedRanges"
            :key="'service-pricing-range-' + index"
            class="text-center">
            <template v-if="range < 99999">{{ range }}</template>
            <template v-else>SET UP</template>
          </th>
        </thead>
        <tbody>
          <tr
            v-for="(service, index) of foundedServices"
            :key="'service-pricing-row-' + index">
            <td class="text-right">
              {{ service.name }}
            </td>
            <td
              v-for="(price, subindex) of service.rangePrices"
              :key="'service-pricing-row-' + index + '-cell-' + subindex"
              class="text-center"
              style="width: 200px;">
              <small v-if="price">
              {{ price }}
              </small>
              <small v-else>
                &mdash;
              </small>
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-else
        show
        theme="warning">
        {{ $t('price.noPricesFoundForServiceGroup') }}&hellip;
      </d-alert>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'request-creator-service-prices-popup',
  props: {
    currencyId: {
      default: 0,
      type: Number
    },
    serviceGroupId: {
      default: 0,
      type: Number
    },
    services: {
      default: () => ([]),
      type: Array
    },
    servicesGroups: {
      default: () => ([]),
      type: Array
    },
    selectedCurrencySymbol: {
      default: '',
      type: String
    }
  },
  computed: {
    foundedRanges () {
      let ranges = [];
      let filteredServices = this.services.filter(service => service.group_id === this.serviceGroupId);

      for (let i = 0; i < filteredServices.length; i++) {
        if (filteredServices[i].prices.length) {
          for (let j = 0; j < filteredServices[i].prices.length; j++) {
            let value = filteredServices[i].prices[j].value_from;

            if (ranges.indexOf(value) === -1) {
              ranges.push(value);
            }
          }
        }
      }

      ranges.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
      return ranges;
    },
    foundedServices () {
      let filteredServices = this.services.filter(service => service.group_id === this.serviceGroupId);

      filteredServices = filteredServices.map(service => {
        let foundedPrices = [];

        for (let i = 0; i < this.foundedRanges.length; i++) {
          let priceForRange = service.prices.filter(price => price.currency_id === this.currencyId && price.value_from === this.foundedRanges[i]);

          if (priceForRange[0]) {
            foundedPrices.push(Number(priceForRange[0].price).toFixed(2));
          } else {
            foundedPrices.push(false);
          }
        }

        return {
          name: service.name,
          rangePrices: foundedPrices
        };
      });

      return filteredServices;
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('request-creator-service-prices-popup-close');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>

<style lang="scss" scoped>
.modal /deep/ .modal-dialog {
  max-width: 1000px;
  width: 100%;

  .modal-body {
    max-height: 80vh;
    overflow: auto;
  }
}
</style>
